import { Plus } from 'lucide-react';

export const LogoLoader = ({ label = 'Finding the best dermatologists...', className = 'py-20' }) => (
  <div className={`flex flex-col items-center justify-center gap-4 ${className}`} data-testid="logo-loader" role="status">
    <div className="flex items-center gap-3">
      <img src="/brand/logo-dark.png" alt="DrPortals" className="h-10 md:h-12 w-auto animate-pulse" />
      <span className="w-9 h-9 rounded-full bg-[#43a047] flex items-center justify-center shadow-md animate-spin [animation-duration:1.4s]">
        <Plus className="w-5 h-5 text-white" strokeWidth={3} />
      </span>
    </div>
    <p className="text-sm text-gray-500" data-testid="logo-loader-label">{label}</p>
  </div>
);
